import { cn } from '@/service/utils/cn';

export const BrandLoader = ({ className }: { className?: string }) => {
    return (
        <div
            className={cn(
                'flex h-[50vh] w-full items-center justify-center',
                className ? ' ' + className : ''
            )}
            data-test-id="brand-loader"
        >
            <object className="h-48 w-48" type="image/svg+xml" data="/icon/BrandLoader.svg">
                svg-animation
            </object>
        </div>
    );
};
